import GitInfo from 'react-git-info/macro'
import packageJson from '../package.json'

const gitInfo = GitInfo()

let confProp
if (process.env.REACT_APP_TARGET === 'production') {
  if (process.env.REACT_APP_SERVER === 'officemail') {
    confProp = {
      DEBUG: false,
      SERVER: {
        restLandigURL: 'https://auth.officemail.io/api/v1',
        URL: 'https://api.officemail.io/graphql',
        restURL: 'https://api.officemail.io/v1',
        officeNextURL: 'https://api.officenext.net',
        migrationURL: 'https://migration-api.officemail.io',
        safeboxURL: 'https://api.safebox.biz',
        logoApiURL: 'https://api.logo.bi',
        wsAddress: null,
        wsURL: null,
      },
      officeNextURL: 'https://org.officenext.net',
    }
  } else {
    confProp = {
      DEBUG: false,
      SERVER: {
        restLandigURL: 'https://auth.officemail.io/api/v1',
        URL: 'https://api.officemail.io/graphql',
        restURL: 'https://api.officemail.io/v1',
        officeNextURL: 'https://api.officenext.net',
        migrationURL: 'https://migration-api.officemail.io',
        safeboxURL: 'https://api.safebox.biz',
        logoApiURL: 'https://api.logo.bi',
        wsAddress: null,
        wsURL: null,
      },
      officeNextURL: 'https://org.officenext.net',
    }
  }
} else if (process.env.REACT_APP_TARGET === 'test') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://auth.officemail.app/api/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      restURL: 'https://dev-api.officemail.io/v1',
      officeNextURL: 'https://dev-api.officenext.net',
      migrationURL: 'https://migration-api.officemail.app',
      safeboxURL: 'https://dev-api.safebox.biz',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://dev-org.officenext.net',
  }
} else if (process.env.REACT_APP_TARGET === 'log') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://dev-api.officemail.io/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      restURL: 'https://dev-api.officemail.io/v1',
      officeNextURL: 'https://dev-api.officenext.net',
      migrationURL: 'https://migration-api.officemail.app/v1',
      safeboxURL: 'https://dev-api.safebox.biz',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://dev-org.officenext.net',
  }
} else {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://dev-api.officemail.io/v1',
      URL: 'https://dev-api.officemail.io/graphql',
      restURL: 'https://dev-api.officemail.io/v1',
      officeNextURL: 'https://dev-api.officenext.net',
      migrationURL: 'https://migration-api.officemail.app/v1',
      safeboxURL: 'https://192.168.50.100:8686',
      logoApiURL: 'https://api.logo.bi',
      wsAddress: null,
      wsURL: null,
    },
    officeNextURL: 'https://dev-org.officenext.net',
  }
}

confProp.defaultLocale = window.navigator.language || window.navigator.userLanguage || 'en-US' // 'ko-KR'

if (window.globalConfig != null) {
  if (window.globalConfig.restURL != null) {
    confProp.SERVER.restURL = window.globalConfig.restURL
  }
  if (window.globalConfig.URL != null) {
    confProp.SERVER.URL = window.globalConfig.URL
  }
  if (window.globalConfig.LOCALE != null) {
    confProp.defaultLocale = window.globalConfig.LOCALE
  }
}

confProp.gitInfo = gitInfo
confProp.packageInfo = packageJson

const conf = confProp

export default conf
